import { Text } from 'ui';

type P = {
  text?: string;
};

const Separator = ({ text }: P) => (
  <div className="form-separator">
    {text ? (
      <Text className="form-separator__text" size="small">
        {text}
      </Text>
    ) : null}
  </div>
);

export default Separator;
